import React from 'react';
import config from '@root/config';

const NoResults = (props) => (
    <div className="scroll-window__card blank-state" style={{ display: 'block' }}>
        <div className="blank-state__img">
            <img src={`${config.folder}static/assets/images/nodoctor.png`} />
        </div>
        <div className="blank-state__text">
            <h5 className="text-bold">Tidak ada dokter yang bertugas</h5>
        </div>
        <div className="blank-state__button">
            <button onClick={() => {
                props.onGoBack();
            }} className="btn btn-green w-100">Kembali</button>
        </div>
    </div>
);

export default NoResults;